var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.267344 1.14973C0.427344 0.989727 0.61401 0.909727 0.827344 0.909727C1.04068 0.909727 1.20068 0.989727 1.30734 1.14973L5.30734 5.14973L9.30734 1.14973C9.41401 0.989727 9.57401 0.909727 9.78734 0.909727C10.0007 0.909727 10.1873 0.989727 10.3473 1.14973C10.5073 1.30973 10.5873 1.49639 10.5873 1.70973C10.5873 1.92306 10.5073 2.08306 10.3473 2.18973L6.34734 6.18973L10.3473 10.1897C10.5073 10.2964 10.5873 10.4564 10.5873 10.6697C10.5873 10.8831 10.5073 11.0697 10.3473 11.2297C10.1873 11.3897 10.0007 11.4697 9.78734 11.4697C9.57401 11.4697 9.41401 11.3897 9.30734 11.2297L5.30734 7.22973L1.30734 11.2297C1.20068 11.3897 1.04068 11.4697 0.827344 11.4697C0.61401 11.4697 0.427344 11.3897 0.267344 11.2297C0.107344 11.0697 0.0273438 10.8831 0.0273438 10.6697C0.0273438 10.4564 0.107344 10.2964 0.267344 10.1897L4.26734 6.18973L0.267344 2.18973C0.107344 2.08306 0.0273438 1.92306 0.0273438 1.70973C0.0273438 1.49639 0.107344 1.30973 0.267344 1.14973Z",
    fill: "#333335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.71c2738f2eb84d4c123cda4ec78b77cf.svg";
export { ForwardRef as ReactComponent };